import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "totalWrap",
  style: {"height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TPCommonHeader = _resolveComponent("TPCommonHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_TPInquiryModal = _resolveComponent("TPInquiryModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TPCommonHeader),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view, { pToggleInquiryModal: _ctx.toggleInquiryModal }, null, 8, ["pToggleInquiryModal"])
    ]),
    (_ctx.showInquiryModal)
      ? (_openBlock(), _createBlock(_component_TPInquiryModal, {
          key: 0,
          pToggleInquiryModal: _ctx.toggleInquiryModal
        }, null, 8, ["pToggleInquiryModal"]))
      : _createCommentVNode("", true)
  ], 64))
}